// ChoralEditorialWorkspace.jsx
import React, { useEffect, useState } from "react";
import ChoralEditorialList from "./ChoralEditorialList";
import ChoralEditorialDetail from "./ChoralEditorialDetail";
import DuplicateWorkbench from "./DuplicateWorkbench";
import "./choral-editorial.css";

const DEFAULT_API = "/api/admin/choral";

function StatsStrip({ stats }) {
  if (!stats) return null;
  const items = [
    { label: "Catalog total",     value: stats.catalog_total,             key: "catalog_total" },
    { label: "Verified",          value: stats.verified,                  key: "verified" },
    { label: "Editor reviewed",   value: stats.editor_reviewed,           key: "editor_reviewed", highlight: true },
    { label: "AI reviewed",       value: stats.ai_reviewed,               key: "ai_reviewed" },
    { label: "Draft",             value: stats.draft,                     key: "draft" },
    { label: "Archived",          value: stats.archived,                  key: "archived" },
    { label: "Audit entries",     value: stats.audit_total,               key: "audit_total" },
    { label: "AI suggestions",    value: stats.pending_ai_suggestions,    key: "pending_ai" },
    { label: "Duplicate hints",   value: stats.duplicate_hints_unresolved, key: "duplicates" },
  ];
  return (
    <div className="ce-stats" data-testid="ce-stats">
      {items.map((it) => (
        <div
          key={it.key}
          className={"ce-stat" + (it.highlight ? " ce-stat--needs" : "")}
          data-testid={`ce-stat-${it.key}`}
        >
          <p className="ce-stat__label">
            {it.highlight ? "Needs My Verification" : it.label}
          </p>
          <p className="ce-stat__value">{it.value ?? "—"}</p>
        </div>
      ))}
    </div>
  );
}

export default function ChoralEditorialWorkspace({
  apiBase = DEFAULT_API,
  statsPath = "/stats",
  duplicatesPath = "/duplicates",
  canVerify = false,
  readOnly = false,
}) {
  const [selectedId, setSelectedId] = useState(null);
  const [stats, setStats]           = useState(null);
  const [duplicates, setDuplicates] = useState({ items: [], total: 0 });

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const [sRes, dRes] = await Promise.all([
          fetch(`${apiBase}${statsPath}`, { credentials: "include" }),
          fetch(`${apiBase}${duplicatesPath}`, { credentials: "include" }).catch(() => null),
        ]);
        if (!cancelled && sRes?.ok)      setStats(await sRes.json());
        if (!cancelled && dRes?.ok)      setDuplicates(await dRes.json());
      } catch {}
    }
    load();
    return () => { cancelled = true; };
  }, [apiBase, statsPath, duplicatesPath]);

  return (
    <main className="ce-workspace" data-testid="ce-workspace">
      <header className="ce-workspace__header">
        <p className="ce-eyebrow">Musical Intelligence™</p>
        <h1>Choral Intelligence™</h1>
        <p>Editorial catalog and verification workspace</p>
      </header>

      <StatsStrip stats={stats} />

      <div className="ce-workspace__layout">
        <ChoralEditorialList
          selectedId={selectedId}
          onSelect={setSelectedId}
          apiBase={apiBase}
        />
        <ChoralEditorialDetail
          workId={selectedId}
          apiBase={apiBase}
          canVerify={canVerify}
          readOnly={readOnly}
        />
      </div>

      <DuplicateWorkbench items={duplicates.items || []} />
    </main>
  );
}
